<template>
  <div>
    <el-card>
      <!-- 搜索区域 -->
      <el-form ref="queryFormRef" :model="queryForm" class="queryFormClass">
        <el-row>
          <el-col :span="7">
            <el-form-item :label="$t('dictionary.dictionaryType') + '：'">
              <el-input
                v-model.trim="queryForm.params.dictType"
                :placeholder="$t('dictionary.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('dictionary.dictionaryName') + '：'">
              <el-input
                v-model.trim="queryForm.params.dictName"
                :placeholder="$t('dictionary.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row justify="start" type="flex">
        <el-col :span="12">
          <div>
            <el-button
              icon="el-icon-search" size="mini" type="primary"
              @click="searchTableData"
            >
              {{ $t('dictionary.search') }}
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="queryFormReset">{{ $t('dictionary.reset') }}
            </el-button>
            <el-button
              icon="el-icon-plus" plain size="mini"
              type="primary" @click="addDictType"
            >{{ $t('dictionary.add') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider />
    </el-card>
    <el-card style="margin-top: 20px">
      <!-- 表格区域 - 可滚动 -->
      <div>
        <el-table
          :data="tableData"
          border
          height="500px"
          style="width: 100%"
          @row-click="manageData"
        >
          <el-table-column
            :label="$t('dictionary.dictionaryType')"
            align="center"
            min-width="180"
            prop="dictType"
          />
          <el-table-column
            :label="$t('dictionary.dictionaryName')"
            align="center"
            min-width="120"
            prop="dictName"
          />
          <el-table-column
            :label="$t('GlobalSetObj.status')"
            align="center"
            min-width="70"
            prop="status"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                {{
                  scope.row.status === 1 ? $t('GlobalSetObj.enable') : $t('GlobalSetObj.disable')
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('dictionary.isSystem')" align="center" min-width="75">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSystem ? 'success' : 'info'" size="small">
                {{ scope.row.isSystem ? $t('dictionary.yes') : $t('dictionary.no') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('GlobalSetObj.remark')"
            align="center"
            min-width="140"
            prop="remark"
            show-overflow-tooltip
          />
          <el-table-column
            :label="$t('roleManage.creator')"
            align="center"
            min-width="90"
            prop="createUserName"
          />
          <el-table-column
            :label="$t('dictionary.CreationTime')"
            align="center"
            min-width="145"
            prop="createTime"
          />
          <el-table-column
            :label="$t('roleManage.ModifiedBy')"
            align="center"
            min-width="90"
            prop="updateUserName"
          />
          <el-table-column
            :label="$t('dictionary.ModificationTime')"
            align="center"
            min-width="145"
            prop="updateTime"
          />
          <el-table-column :label="$t('dictionary.operation')" align="center" width="110">
            <template slot-scope="scope">
              <div class="operationBtns">
                <el-tooltip :content="$t('dictionary.modify')" placement="top">
                  <el-button
                    :disabled="scope.row.isSystem"
                    icon="el-icon-edit"
                    size="small"
                    type="text"
                    @click.stop="putClick(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip :content="$t('dictionary.manageData')" placement="top">
                  <el-button
                    icon="el-icon-s-operation"
                    size="small"
                    type="text"
                    @click.stop="manageData(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip :content="$t('GlobalSetObj.Delete')" placement="top">
                  <el-button
                    v-permit:remove="'but:configurationManagement:newDictType:delete'"
                    :disabled="scope.row.isSystem"
                    icon="el-icon-delete"
                    size="small"
                    type="text"
                    @click.stop="deleteDictType(scope.row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="block">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="getTableData"
          @current-change="getTableData"
        />
      </div>
    </el-card>
    <!-- DictType 详情/新增/修改 Drawer -->
    <el-drawer
      :direction="direction"
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      size="700px"
    >
      <div class="drawerContent">
        <el-form
          ref="dictTypeFormRef"
          :label-position="labelPosition"
          :model="dictTypeForm"
          :rules="dictTypeRules"
          label-width="120px"
        >
          <el-form-item :label="$t('dictionary.dictionaryType') + '：'" prop="dictType">
            <el-input
              v-model="dictTypeForm.dictType"
              :disabled="isEdit || isDetail || isSystemDict"
              :placeholder="$t('dictionary.dictTypeKeyFormat')"
            />
          </el-form-item>
          <el-form-item :label="$t('dictionary.dictionaryName') + '：'" prop="dictName">
            <el-input
              v-model="dictTypeForm.dictName"
              :disabled="isDetail || isSystemDict"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.status') + '：'" prop="status">
            <el-radio-group v-model="dictTypeForm.status" :disabled="isDetail || isSystemDict">
              <el-radio :label="1">{{ $t('GlobalSetObj.enable') }}</el-radio>
              <el-radio :label="0">{{ $t('GlobalSetObj.disable') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.remark') + '：'">
            <el-input
              v-model="dictTypeForm.remark"
              :disabled="isDetail || isSystemDict"
              :placeholder="$t('dictionary.pleaseInput')"
              :rows="3"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div v-if="!isDetail" class="drawerFooter">
          <el-button @click="drawerVisible = false">{{ $t('collectionCenter.cancel') }}</el-button>
          <el-button type="primary" @click="submitDictType">{{ $t('dictionary.submit') }}
          </el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 字典数据管理 Drawer -->
    <el-drawer
      :direction="direction"
      :title="dataDrawerTitle"
      :visible.sync="dataDrawerVisible"
      size="85%"
    >
      <div class="drawerContent dataDrawerContent">
        <div class="dataManageHeader">
          <span class="dictTypeTag">{{ currentDictType }}</span>
          <el-button
            icon="el-icon-plus" size="mini" type="primary"
            @click="addDictData"
          >{{ $t('dictionary.add') }}
          </el-button>
        </div>
        <div class="dictDataQueryForm">
          <el-form :model="dictDataQuery" inline size="mini">
            <el-form-item :label="$t('dictionary.dictionaryV') + '：'">
              <el-input
                v-model.trim="dictDataQuery.params.dictValue"
                :placeholder="$t('dictionary.pleaseInput')"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('GlobalSetObj.remark') + '：'">
              <el-input
                v-model.trim="dictDataQuery.params.remark"
                :placeholder="$t('dictionary.pleaseInput')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search" size="mini" type="primary"
                @click="searchDictData"
              >
                {{ $t('dictionary.search') }}
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="dictDataQueryReset">{{ $t('dictionary.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="dataTableArea">
          <el-table
            :data="dictDataTable" border height="100%"
            style="width: 100%"
          >
            <el-table-column
              :label="$t('dictionary.dictionaryV')"
              align="center"
              min-width="110"
              prop="dictValue"
            />
            <el-table-column
              :label="$t('dictionary.dictLabel')"
              align="center"
              min-width="110"
              prop="dictLabel"
            />
            <el-table-column
              :label="$t('dictionary.multiLangConfig')"
              align="center"
              min-width="160"
            >
              <template slot-scope="scope">
                <div class="langTags">
                  <el-tooltip
                    :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.zh || '-' : '-'"
                    :disabled="
                      !(
                        scope.row.dictLabelMap &&
                        scope.row.dictLabelMap.zh &&
                        scope.row.dictLabelMap.zh.length > 8
                      )
                    "
                    placement="top"
                  >
                    <span class="langTagText">{{ $t('dictionary.zhLang') }}:
                      {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.zh : '-' }}</span>
                  </el-tooltip>
                  <el-tooltip
                    :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.en || '-' : '-'"
                    :disabled="
                      !(
                        scope.row.dictLabelMap &&
                        scope.row.dictLabelMap.en &&
                        scope.row.dictLabelMap.en.length > 8
                      )
                    "
                    placement="top"
                  >
                    <span class="langTagText">{{ $t('dictionary.enLang') }}:
                      {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.en : '-' }}</span>
                  </el-tooltip>
                  <el-tooltip
                    :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.pu || '-' : '-'"
                    :disabled="
                      !(
                        scope.row.dictLabelMap &&
                        scope.row.dictLabelMap.pu &&
                        scope.row.dictLabelMap.pu.length > 8
                      )
                    "
                    placement="top"
                  >
                    <span class="langTagText">{{ $t('dictionary.puLang') }}:
                      {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.pu : '-' }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('GlobalSetObj.remark')"
              align="center"
              min-width="100"
              prop="remark"
              show-overflow-tooltip
            />
            <el-table-column
              :label="$t('dictionary.sortOrder')"
              align="center"
              prop="sortOrder"
              width="70"
            />
            <el-table-column
              :label="$t('GlobalSetObj.status')"
              align="center"
              prop="status"
              width="75"
            >
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                  {{
                    scope.row.status === 1 ? $t('GlobalSetObj.enable') : $t('GlobalSetObj.disable')
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column :label="$t('dictionary.isSystem')" align="center" width="85">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isSystem ? 'success' : 'info'" size="small">
                  {{ scope.row.isSystem ? $t('dictionary.yes') : $t('dictionary.no') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('roleManage.creator')"
              align="center"
              min-width="100"
              prop="createUserName"
            />
            <el-table-column
              :label="$t('dictionary.CreationTime')"
              align="center"
              min-width="150"
              prop="createTime"
            />
            <el-table-column
              :label="$t('roleManage.ModifiedBy')"
              align="center"
              min-width="100"
              prop="updateUserName"
            />
            <el-table-column
              :label="$t('dictionary.ModificationTime')"
              align="center"
              min-width="150"
              prop="updateTime"
            />
            <el-table-column :label="$t('dictionary.operation')" align="center" width="90">
              <template slot-scope="scope">
                <div class="operationBtns">
                  <el-tooltip :content="$t('dictionary.edit')" placement="top">
                    <el-button
                      :disabled="scope.row.isSystem"
                      icon="el-icon-edit"
                      size="small"
                      type="text"
                      @click.stop="editDictData(scope.row)"
                    />
                  </el-tooltip>
                  <el-tooltip :content="$t('GlobalSetObj.Delete')" placement="top">
                    <el-button
                      v-permit:remove="'but:configurationManagement:newDictType:dataDelete'"
                      :disabled="scope.row.isSystem"
                      icon="el-icon-delete"
                      size="small"
                      type="text"
                      @click.stop="deleteDictData(scope.row)"
                    />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="block">
          <el-pagination
            :current-page.sync="dictDataQuery.pageNumber"
            :page-size.sync="dictDataQuery.pageSize"
            :page-sizes="[10, 20, 50]"
            :total="dictDataTotal"
            background
            layout="total, sizes, prev, pager, next"
            @size-change="onDictDataSizeChange"
            @current-change="onDictDataPageChange"
          />
        </div>
      </div>
    </el-drawer>

    <!-- 字典数据 新增/编辑 Drawer -->
    <el-drawer
      :direction="direction"
      :title="dataFormTitle"
      :visible.sync="dataFormVisible"
      size="700px"
    >
      <div class="drawerContent">
        <el-form
          ref="dictDataFormRef"
          :label-position="labelPosition"
          :model="dictDataForm"
          :rules="dictDataRules"
          label-width="120px"
        >
          <el-form-item :label="$t('dictionary.dictionaryValue') + '：'" prop="dictValue">
            <el-input
              v-model="dictDataForm.dictValue"
              :disabled="dataEditId !== null"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item :label="$t('dictionary.dictLabel') + '：'" prop="dictLabel">
            <el-input
              v-model="dictDataForm.dictLabel"
              :placeholder="$t('dictionary.pleaseInput')"
              :rows="2"
              type="textarea"
            />
          </el-form-item>
          <el-form-item :label="$t('dictionary.sortOrder') + '：'" prop="sortOrder">
            <el-input-number v-model="dictDataForm.sortOrder" :max="9999" :min="0" />
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.status') + '：'">
            <el-radio-group v-model="dictDataForm.status">
              <el-radio :label="1">{{ $t('GlobalSetObj.enable') }}</el-radio>
              <el-radio :label="0">{{ $t('GlobalSetObj.disable') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.remark') + '：'">
            <el-input
              v-model="dictDataForm.remark"
              :placeholder="$t('dictionary.pleaseInput')"
              :rows="2"
              type="textarea"
            />
          </el-form-item>
          <!-- 多语言配置 -->
          <el-divider content-position="left">{{ $t('dictionary.multiLangConfig') }}</el-divider>
          <el-form-item :label="$t('dictionary.zhLang') + '：'">
            <el-input
              v-model="dictDataForm.dictLabelMap.zh"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item :label="$t('dictionary.enLang') + '：'">
            <el-input
              v-model="dictDataForm.dictLabelMap.en"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item :label="$t('dictionary.puLang') + '：'">
            <el-input
              v-model="dictDataForm.dictLabelMap.pu"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
        </el-form>
        <div class="drawerFooter">
          <el-button @click="dataFormVisible = false">{{ $t('collectionCenter.cancel') }}
          </el-button>
          <el-button type="primary" @click="submitDictData">{{ $t('dictionary.submit') }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  dictDataDelete,
  dictDataPage,
  dictDataSave,
  dictTypeDelete,
  dictTypePage,
  dictTypeSave
} from '@/api/newDict';

export default {
  name: 'NewDictType',
  data() {
    return {
      direction: 'rtl',
      labelPosition: 'right',

      // 查询表单
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          dictType: '',
          dictName: ''
        }
      },
      tableData: [],
      total: 0,

      // DictType Drawer
      drawerVisible: false,
      drawerTitle: '',
      isEdit: false,
      isDetail: false,
      isSystemDict: false,
      editId: null,
      dictTypeForm: {
        dictType: '',
        dictName: '',
        status: 1,
        remark: ''
      },
      dictTypeRules: {
        dictType: [
          { required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' },
          {
            pattern: /^[a-z][a-z0-9_]*$/,
            message: this.$t('dictionary.dictTypeKeyFormat'),
            trigger: 'blur'
          }
        ],
        dictName: [{ required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }]
      },

      // DictData 管理 Drawer
      dataDrawerVisible: false,
      dataDrawerTitle: '',
      currentDictType: '',
      dictDataTable: [],
      dictDataQuery: {
        pageNumber: 1,
        pageSize: 10,
        params: { dictType: '', dictValue: '', remark: '' },
        needCount: true
      },
      dictDataTotal: 0,

      // DictData 新增/编辑 Drawer
      dataFormVisible: false,
      dataFormTitle: '',
      isDataSystem: false,
      dataEditId: null,
      dictDataForm: {
        dictType: '',
        dictValue: '',
        dictLabel: '',
        dictLabelMap: { zh: '', en: '', pu: '' },
        sortOrder: 0,
        isDefault: false,
        isSystem: false,
        status: 1,
        remark: ''
      },
      dictDataRules: {
        dictValue: [{ required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }],
        dictLabel: [{ required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }]
      }
    };
  },
  computed: {
    dataTableHeight() {
      return window.innerHeight - 180;
    }
  },
  created() {
    this.getTableData();
  },
  mounted() {
    this.$el.parentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    this.$el.parentElement.style.overflow = '';
  },
  methods: {
    // ===================== DictType 列表 =====================
    getTableData() {
      dictTypePage(this.queryForm)
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        })
        .catch(() => {});
    },
    searchTableData() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    queryFormReset() {
      this.queryForm.params.dictType = '';
      this.queryForm.params.dictName = '';
      this.getTableData();
    },

    // ===================== DictType 操作 =====================
    addDictType() {
      this.isEdit = false;
      this.isDetail = false;
      this.isSystemDict = false;
      this.editId = null;
      this.drawerTitle = this.$t('dictionary.add');
      this.drawerVisible = true;
      this.dictTypeForm = {
        dictType: '',
        dictName: '',
        status: 1,
        remark: ''
      };
      this.$nextTick(() => {
        this.$refs.dictTypeFormRef && this.$refs.dictTypeFormRef.clearValidate();
      });
    },
    putClick(row) {
      this.isEdit = true;
      this.isDetail = false;
      this.isSystemDict = row.isSystem;
      this.editId = row.id;
      this.drawerTitle = this.$t('dictionary.modify');
      this.drawerVisible = true;
      this.dictTypeForm = {
        dictType: row.dictType,
        dictName: row.dictName,
        status: row.status,
        remark: row.remark || ''
      };
      this.$nextTick(() => {
        this.$refs.dictTypeFormRef && this.$refs.dictTypeFormRef.clearValidate();
      });
    },
    submitDictType() {
      this.$refs.dictTypeFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          id: this.isEdit ? this.editId : null,
          dictName: this.dictTypeForm.dictName,
          dictType: this.dictTypeForm.dictType,
          status: this.dictTypeForm.status,
          remark: this.dictTypeForm.remark
        };
        dictTypeSave(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.drawerVisible = false;
              this.getTableData();
            }
          })
          .catch(() => {});
      });
    },
    deleteDictType(row) {
      if (row.isSystem) {
        this.$message.warning(this.$t('dictionary.systemCannotDelete'));
        return;
      }
      this.$confirm(this.$t('dictionary.confirmDelete'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      })
        .then(() => {
          dictTypeDelete(row.id)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.DeleteSuccessful'));
                this.getTableData();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },

    // ===================== DictData 管理 =====================
    manageData(row) {
      this.currentDictType = row.dictType;
      this.dataDrawerTitle = this.$t('dictionary.dictDataManage') + ' - ' + row.dictName;
      this.dictDataQuery.params.dictType = row.dictType;
      this.dictDataQuery.params.dictValue = '';
      this.dictDataQuery.params.remark = '';
      this.dictDataQuery.pageNumber = 1;
      this.dictDataQuery.pageSize = 10;
      this.dataDrawerVisible = true;
      this.loadDictData();
    },
    searchDictData() {
      this.dictDataQuery.pageNumber = 1;
      this.loadDictData();
    },
    dictDataQueryReset() {
      this.dictDataQuery.params.dictValue = '';
      this.dictDataQuery.params.remark = '';
      this.dictDataQuery.pageNumber = 1;
      this.loadDictData();
    },
    loadDictData() {
      dictDataPage(this.dictDataQuery)
        .then((res) => {
          if (res.code === 200) {
            this.dictDataTable = res.data.records;
            this.dictDataTotal = res.data.total;
          }
        })
        .catch(() => {});
    },
    onDictDataSizeChange() {
      this.dictDataQuery.pageNumber = 1;
      this.loadDictData();
    },
    onDictDataPageChange() {
      this.loadDictData();
    },
    addDictData() {
      this.isDataSystem = false;
      this.dataEditId = null;
      this.dataFormTitle = this.$t('dictionary.add') + ' - ' + this.currentDictType;
      this.dataFormVisible = true;
      this.dictDataForm = {
        dictType: this.currentDictType,
        dictValue: '',
        dictLabel: '',
        dictLabelMap: { zh: '', en: '', pu: '' },
        sortOrder: 0,
        isDefault: false,
        isSystem: false,
        status: 1,
        remark: ''
      };
      this.$nextTick(() => {
        this.$refs.dictDataFormRef && this.$refs.dictDataFormRef.clearValidate();
      });
    },
    editDictData(row) {
      this.isDataSystem = row.isSystem;
      this.dataEditId = row.id;
      this.dataFormTitle = this.$t('dictionary.edit') + ' - ' + this.currentDictType;
      this.dataFormVisible = true;
      this.dictDataForm = {
        dictType: row.dictType,
        dictValue: row.dictValue,
        dictLabel: row.dictLabel,
        dictLabelMap: row.dictLabelMap
          ? {
            zh: row.dictLabelMap.zh || '',
            en: row.dictLabelMap.en || '',
            pu: row.dictLabelMap.pu || ''
          }
          : { zh: '', en: '', pu: '' },
        sortOrder: row.sortOrder || 0,
        isDefault: row.isDefault || false,
        isSystem: row.isSystem || false,
        status: row.status,
        remark: row.remark || ''
      };
      this.$nextTick(() => {
        this.$refs.dictDataFormRef && this.$refs.dictDataFormRef.clearValidate();
      });
    },
    submitDictData() {
      this.$refs.dictDataFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          id: this.dataEditId,
          dictType: this.dictDataForm.dictType,
          dictValue: this.dictDataForm.dictValue,
          dictLabel: this.dictDataForm.dictLabel,
          dictLabelMap: this.dictDataForm.dictLabelMap,
          sortOrder: this.dictDataForm.sortOrder,
          isDefault: this.dictDataForm.isDefault,
          isSystem: this.dictDataForm.isSystem,
          status: this.dictDataForm.status,
          remark: this.dictDataForm.remark
        };
        dictDataSave(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.dataFormVisible = false;
              this.loadDictData();
            }
          })
          .catch(() => {});
      });
    },
    deleteDictData(row) {
      if (row.isSystem) {
        this.$message.warning(this.$t('dictionary.systemDataCannotDelete'));
        return;
      }
      this.$confirm(this.$t('dictionary.confirmDeleteData'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      })
        .then(() => {
          dictDataDelete(row.id)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.DeleteSuccessful'));
                this.loadDictData();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.newDictBox {
  padding: 20px;
  box-sizing: border-box;
  height: calc(100vh - 90px); /* 减去可能的顶部导航高度 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.searchArea {
  flex-shrink: 0; /* 搜索区域不收缩 */
}

.queryFormClass ::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.queryFormClass ::v-deep .el-form-item__label {
  padding: 0;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 20px;
}

.tableContainer {
  flex: 1;
  overflow: hidden;
  margin-bottom: 10px;
  min-height: 0;
}

.tableContainer ::v-deep .el-table {
  height: 95%;
}

.tableContainer ::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}

.block {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0; /* 分页区域不收缩 */
  padding-top: 10px;
}

.drawerContent {
  padding: 20px;
  box-sizing: border-box;
}

.drawerContent ::v-deep .el-select {
  width: 100%;
}

.drawerFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
}

.dataDrawerContent {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dataManageHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding-bottom: 16px;
}

.dictDataQueryForm {
  flex-shrink: 0;
  padding-bottom: 8px;
}

.dictDataQueryForm ::v-deep .el-form-item {
  margin-bottom: 8px;
}

.dataTableArea {
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.dictTypeTag {
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
}

.langTags {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.langTagText {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  line-height: 20px;
  font-size: 12px;
  background: #f0f2f5;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  color: #909399;
  cursor: default;
}

.operationBtns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.newDictBox ::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
